import { render, staticRenderFns } from "./creditList.vue?vue&type=template&id=23bbee8c&scoped=true"
import script from "./creditList.vue?vue&type=script&lang=js"
export * from "./creditList.vue?vue&type=script&lang=js"
import style0 from "./creditList.vue?vue&type=style&index=0&id=23bbee8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bbee8c",
  null
  
)

export default component.exports